export default __webpack_public_path__ + "images/fc7c7d2bb07d396b87ee7b48439f4dee.jpg";